<template>
  <div>
    <ul class="more-list">
      <li v-for="item in data" :data-id="item.id">{{ item.name }}</li>
    </ul>
  </div>
</template>

<script>
import AppHeader from '@/components/app-header'

export default {
  components: {
    AppHeader
  },

  props: ['data']
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// more-list.vue?70f05fcf